import { FC } from 'react';
import { Table } from 'components';
import { Information } from 'types';

import { Pagination } from 'antd';
import { HistoryReceivingStyled } from 'pages/Notifications/styles';
import moment from 'moment';

type Props = {
  data: {
    notifications: Information[];
    nextPage: number | null;
    prevPage: number | null;
    lastPage: number | null;
    count: number;
    currentPage: number;
  };
  loading: boolean;
  setCurrentSent: (page: number) => void;
};

const BoHistorySending: FC<Props> = ({ data, setCurrentSent, loading }) => {
  const pageSize = 12;
  return (
    <HistoryReceivingStyled style={{ display: 'block' }}>
      <Table<Information>
        columns={columns}
        dataSource={(data.notifications && data.notifications) || []}
        loading={loading}
        rowKey={({ information_id }) => information_id}
      />
      {data?.notifications && data?.notifications.length > 1 && (
        <Pagination
          className="pagination"
          current={data?.currentPage}
          onChange={(page) => setCurrentSent(page)}
          pageSize={pageSize}
          total={data?.count}
          showSizeChanger={false}
        />
      )}
    </HistoryReceivingStyled>
  );
};

export default BoHistorySending;

const columns = [
  {
    title: '送信日時',
    dataIndex: 'date',
    width: '20%',
    render: (date: string) => <>{moment(date).format('YYYY/MM/DD HH:mm')}</>,
  },
  {
    title: '現場名',
    dataIndex: 'site_name',
    width: '20%',
    render: (site_name: string) => <div className="border-left">{site_name}</div>,
  },
  {
    title: '内容',
    dataIndex: 'content',
    render: (content: string) => (
      <div className="border-left" style={{ wordBreak: 'break-word' }}>
        {content}
      </div>
    ),
  },
];
